import React from 'react'
import CustomSnackBar from './Mui/CustomSnackBar';
import Typography from '@material-ui/core/Typography';

import {
  capitalize
} from '../helpers'

class MyClass extends React.Component {
  state = {
    snackbar: {
      open: false,
      message: '',
      variant: 'info'
    }
  }

  SnackBar = state => (
    <CustomSnackBar
      open={state.open}
      message={state.message}
      variant={state.variant}
      handleClose={this.handleHideSnackbar.bind(this)}
    />
  )

  showSnackbar(variant, message) {
    let messageString
    if (message instanceof Array) {
      messageString = message.map( (m,i) => {
        return <span key={i} style={{display:'block !important'}}>{m}</span>
      })
    } else if ( typeof message === 'object') {
      messageString = Object.keys(message).map( (k,i) => {
        const l = (k === "base") ? "" : `${capitalize(k)} `
        // return <span key={i} style={{display:'block !important'}}>{l}{message[k]}</span>
        return `${l}${message[k].join("\n")}`
      }).join("\n")
    } else {
      messageString = message
    }

    this.setState({
      snackbar: {
        open: true,
        variant: variant,
        message: (
          <div>
            <Typography className="body2 c-white">
              {messageString}
            </Typography>
          </div>
        )
      }
    })
  }

  handleHideSnackbar() {
    this.setState({
      snackbar: {
        open: false,
        message: '',
        variant: 'info'
      }
    })
  }


}

export default MyClass



// WEBPACK FOOTER //
// ./src/js/components/HasSnackbar.js